import React, { useEffect, useState, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useTranslation } from 'react-i18next';
import { setBlindScanBatchEffect } from '../../../actions/tosbActions';
import { showAlertSnackbar } from '../../../reducers/uiSlice';

function BlindBatchList(props) {
    const { open, handleClose, blindBatchRes } = props;
    const dispatch = useDispatch();
    const {t} = useTranslation('transferOrdersSubBatch');

    const moment = require('moment');

    const [rows, setRows] = useState([]);

    function handleUpdate(warehouse, batch) {
        dispatch(setBlindScanBatchEffect(warehouse, batch))
        .then(() => {
            dispatch(showAlertSnackbar({message: 'success', type: 'success'}))
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: 'error', type: 'error'}))
        })
    }

    useEffect(() => {
        if(blindBatchRes) {
            setRows(blindBatchRes)
        }
    }, [blindBatchRes])

    return (
        <Fragment>
            <Dialog
                maxWidth='sm'
                open={open}
                onClose={handleClose} 
            >
                <DialogContent dividers style={{ display: 'flex'}}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align='center'>{t('batch')}</TableCell>
                                <TableCell align='center'>{t('warehouse')}</TableCell>
                                <TableCell align='center'>{t('create_time')}</TableCell>
                                <TableCell align='center'>{t('operation')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {
                            rows.map((row) => (
                                <TableRow>
                                    <TableCell align='center'>{row.referer}</TableCell>
                                    <TableCell align='center'>{row.warehouse}</TableCell>
                                    <TableCell align='center'>{moment.unix(row.eta).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                                    <TableCell align='center'>
                                        <Button
                                            variant='contained'
                                            color='secondary'
                                            onClick={()=>handleUpdate(row.warehouse, row.referer)}
                                        >
                                            {t('update_immediately')}
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                        </TableBody>
                    </Table>
                </DialogContent>
            </Dialog>
        </Fragment>
        
    );
}

export default BlindBatchList;
